module.exports = __webpack_public_path__ + "static/media/Nike-logo.efc67024.jpg";